<template>
  <section id="about">
    <b-container style="margin-top: 0; margin-bottom: 0">
      <b-row>
        <b-col cols="12" md="12" lg="12" align="center">
          <h3>
            {{ $t('about.title') }}
          </h3>
          </b-col>
        </b-row>
      </b-container>
    <b-container>
      <b-row>
        <b-col cols="12" md="12" lg="6">
          <img class="img img__shadowed" style="margin-top: 1rem" src="@/assets/bitabout.jpg" alt />
        </b-col>
        <b-col cols="12" md="12" lg="6">
          <p class="d-block d-lg-block">{{ $t('about.paragraph1Lead') }} <b style="color: orange; font-size:1.2rem">CryptoCa$h</b> {{ $t('about.paragraph1Body') }} <a href="#change" style="color: orange">{{ $t('about.exchangeProcessLink') }}</a> {{ $t('about.exchangeProcessTail') }}</p>
          <p class="d-block d-lg-block">{{ $t('about.paragraph2') }}</p>
        </b-col>
         <b-col cols="12" md="12" lg="12">
          <p class="d-block d-lg-block">{{ $t('about.paragraph3') }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
          <a
            class="btn btn__primary"
            href="https://telegram.me/MoneyCashBit"
            target="_blank"
          >{{ $t('common.telegramCta') }}</a>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {};
</script>

<style lang='sass'>
.info
  .btn__primary
    width: 40%
</style>